export const showOnSmall = "s1k3sxik";
export const hideOnSmall = "hz01fmf";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");